export const tastySnails = {
  id: "tastySnails",
  link: "/#/recipes/recipes/tastySnails",
  name: "Tasty Snails",
  cuisine: "Babath",
  summary: "Savory snails and peppers",
  inspiration: "Peppered Snail",
  quantity: "4 servings",
  time: "90 minutes",
  notes:
    "We know very little about the food from Babatharnam. In fact, the \"tasty snails\" quote is all we've got. In my research I found that there are more real-world cultures than I had realized that have snail dishes. I went with Nigerian peppered snail as the starting point since I'm using African influences for some of the other western Rosharan dishes. As for which type of snails to use, I used apple snails as they were what I had available. Other varieties of snails should work as well.",
  quotes:
    "Babatharnam. My cousin cousin cousin visited there one time. They have very tasty snails. (The Way of Kings ch 46)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/tasty-snails-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "snails",
          display: "1 lb snail meat (apple snails or similar)"
        },
        {
          item: "lemon",
          display: "1 lemon"
        },
        {
          item: "dashi",
          display: "1 1/2 tsp bonito granules (hon dashi), divided"
        },
        {
          item: "blackPepper",
          display: "1 tsp ground black pepper"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "hotPeppers",
          display: "1 jalapeño"
        },
        {
          item: "bellPepper",
          display: "1 red bell pepper"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic"
        },
        {
          item: "oliveOil",
          display: "1 tbsp olive oil"
        },
        {
          item: "paprika",
          display: "1 tsp paprika"
        },
        {
          item: "fishSauce",
          display: "1 tbsp fish sauce"
        }
      ]
    }
  ],
  steps: [
    "If the snails are fresh in shell, foil them in plenty of water over high heat for 5 minutes. Drain, then remove the snails from the shells. If using frozen shelled snail meat, just defrost it.",
    "Add the snail meat to a pot and cover with fresh cold water. Squeeze the lemon into the water and mix. Let sit 10 minutes.",
    "Scrub the snails with the lemon peel to remove the slime. Rinse very well. Dump out the water in the pot and rinse the pot.",
    "Return the snails to the pot. Cover with water plus an extra inch. Add 1 tsp hon dashi, the black pepper, and the salt. Cover and bring to a boil over hight heat, then reduce heat and simmer for 30 minutes until snails are tender. Check occasionally to see if the pepper is clinging to the sides of the pan, and scrape it back into the water if so.",
    "Meanwhile, mince the jalapeño. Chop the red bell pepper into 1 inch pieces. Peel and chop the onion, and peel and mince the garlic.",
    "Add the olive oil to a medium size pan over medium high heat. Add the onion and cook 5 minutes until translucent. Add the garlic, bell pepper, jalapeño, 1/2 tsp hon dashi, paprika and fish sauce. Reduce heat to medium and cook and stir for 5 minutes. Remove from heat until snails are done simmering.",
    "Once the snails are done, drain them and discard the liquid. Add the drained snails to the pan along with 2 tbsp water. Heat over high heat until you hear it sizzling, then cover and reduce heat to medium low. Cook for 10 minutes, stirring occasionally. Serve warm."
  ]
}
